import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import IconColored from 'components/IconColored';
import ROUTES from 'routes';
import { WindowSizeContext } from 'contexts';
import Error500Internal from 'pages/ErrorPage/Error500Internal';
import Typography from 'components/ui/Typography';
import Error401Unauthorized from 'pages/ErrorPage/Error401Unauthorized';

import Error404NotFound from './Error404NotFound';

import css from './ErrorPage.module.scss';

interface Props {
    type: 401 | 404 | 500;
    errorMsg?: string;
    retryHandler?: () => void;
    isModal?: boolean;
}

const ErrorPage: React.FC<Props> = ({ retryHandler, errorMsg, type, isModal = false }) => {
    const { t } = useTranslation();

    const { isMobile } = useContext(WindowSizeContext);

    return (
        <div className={clsx(css.container, isModal && css.modal)}>
            <IconColored name="error-cat" width={isMobile ? 300 : 400} />
            {type === 401 && <Error401Unauthorized />}
            {type === 404 && <Error404NotFound />}
            {type === 500 && <Error500Internal retryHandler={retryHandler} errorMsg={errorMsg} />}
            <Link to={ROUTES.SUPPORT}>
                <Typography color="dark-blue">{t('ErrorInfo.SendFeedback')}</Typography>
            </Link>
        </div>
    );
};

export default ErrorPage;
